// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck - may need to be at the start of file
import React, { FC, memo, Ref } from 'react';
import {TextInput, TextInputProps, ViewStyle} from 'react-native';
import { Container, OTPInput } from '@fkhplus/common/src/components/atoms/OTPInput/styles';

export interface IOtpInputBoxProps extends TextInputProps {
    containerStyle: ViewStyle;
    inputStyle: ViewStyle;
    refCallback: any;
    hasError?:boolean;
}


const OtpInputBox : FC<IOtpInputBoxProps>= (props:IOtpInputBoxProps):React.ReactElement =>{
  const {
    inputStyle,
    refCallback,
    ...remainingProps
  } = props;

  return (
    <Container styleProp={props}>
      <OTPInput
        style={inputStyle}
        ref={refCallback}
        textAlign='center'
        {...remainingProps}
      />
    </Container>
  );
};






export default memo(OtpInputBox);
